import AgentSidebar from "./AgentSidebar";
import MobileSidebar from "./MobileSidebar";

const SidebarIndex = () => {
  return (
    <>
      <AgentSidebar />
      <MobileSidebar />
    </>
  );
};

export default SidebarIndex;
